@if (loading && !policyNotFound) {
  <div
    class="cds-flex cds-flex-col cds-justify-center cds-items-center cds-p-3 md:cds-p-0 cds-gap-2 cds-h-full"
    data-testid="searching-screen">
    <p-progress-spinner/>
    <h3 class="cds-mt-6 cds-text-center">Searching Policy</h3>
    <p class="body-regular cds-text-center">Please wait while the system retrieves the policy</p>
  </div>
} @else if (!loading && policyNotFound) {
  <app-policy-not-found/>
} @else {
  <app-policy-summary
    [rawPolicySummaries]="policies"
    [variantDownloadQueue]="downloadQueue"
    (navigateToBaseQFA)="addNewQFA()"
    (downloadVariantQuote)="downloadQuote($event)"/>
}
